import type React from 'react';

import styles from './styles.module.scss';

interface OtherContainerProps {
  children: React.ReactNode;
}

const OtherContainer: React.FC<OtherContainerProps> = props => {
  return <div className={styles.othercontainer}>{props.children}</div>;
};

export default OtherContainer;
